import * as React from 'react';
import { useEffect, useState } from 'react';
import { Grid } from "@mui/material"
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import img01 from "../../assets/images/img01.jpg";
import EventBusyIcon from '@mui/icons-material/EventBusy';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import api from "../../utils/api_v2";
import LodingData from "../../utils/LodingData";
import * as util from "../../utils/util";
import BeenhereIcon from '@mui/icons-material/Beenhere';
import tabbg from "../../assets/images/tab_01.png"
import axios from 'axios';

const ReservationView = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = (hoName: any, ipDate: any, rsvId: any, reservation: any) => {
    setSelectedHoName(hoName);
    setSelectedIpDate(ipDate);
    setSelectedReservationId(rsvId);
    setSelectedReservation(reservation);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [reservations, setReservations] = useState([]);
  const [selectedHoName, setSelectedHoName] = React.useState('');
  const [selectedIpDate, setSelectedIpDate] = React.useState('');
  const [selectedReservationId, setSelectedReservationId] = React.useState('');
  const [selectedReservation, setSelectedReservation] = React.useState({});

  const [reservationSelfList, setReservationSelfList] = useState([]);
  const [reservationFamList, setReservationFamList] = useState([]);

  const [inspectionList, setInspectionList] = useState([]);
  const [counselList, setCounselList] = useState([]);
  const [allListCnt, setAllListCnt] = useState(0);

  useEffect(() => {
    // 예약 현황 목록 (접속자/접속자 가족 전부)
    LodingData(() => api.post('customer/api/v1/CU_004_001', { cusId: window.localStorage.userCusID }).then((res: any) => {
      // const reservationData = res.data.inspection.concat(res.data.counsel);
      // setReservations(reservationData);

      // let tempSelfList: any = [];
      // let tempFamList: any = [];

      // let currentYear = new Date().getFullYear();
      // 본인 or 가족
      // for (let i = 0; i < reservationData.length; i++) {
      //   if (parseInt((reservationData[i].firstWishDate).substring(0, 4)) === currentYear) {
      //     tempSelfList.push(reservationData[i]);
      //   } else {
      //     tempFamList.push(reservationData[i]);
      //   }
      // }

      // setReservationSelfList(tempSelfList);
      // setReservationFamList(tempFamList);

      const nowYear = new Date().getFullYear().toString();

      // 건강검진
      setInspectionList(res.data.inspection.filter((v: any) => v.reservationStatus.code >= 0
          && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear))); // 해당연도 && 예약대기, 예약확정, 수진완료, 결과등록 데이터만 출력

      // 심리상담
      setCounselList(res.data.counsel.filter((v: any) => v.reservationStatus.code >= 0
      && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear)));

      // 총 갯수
      setAllListCnt(res.data.inspection.concat(res.data.counsel).filter((v: any) => v.reservationStatus.code >= 0
      && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear)).length);
    }).catch(function (error: any) {
      console.log(error)
    }));
  }, []);

  // 예약 취소
  function handleClickCancleReservation() {
    LodingData(() => api.post('customer/api/v1/CU_004_002', { rsvId: selectedReservationId }).then((res: any) => {
      sendAT(selectedReservation);
      window.location.reload();
    }).catch(function (error: any) {
      console.log(error)
    }));
  }

  // 예약 상태에 따른 문구
  function showStatus(reservation: any) {
    if (reservation.reservationStatus.name === '예약대기') {
      return (
        // <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
        //   <Button sx={{ color: '#555', flex: 3, textAlign: 'center', p: 1 }}
        //     onClick={() => handleClickOpen(reservation.hoName, reservation.firstWishDate, reservation.rsvId)}>예약취소</Button>
        //   <Divider orientation="vertical" variant="middle" flexItem />
        //   <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../check/CreateCounsel') }}>문의</Button>
        // </Stack>
        // <Typography sx={{fontSize: 14, color:'#c72a2a', mt: 1}}>※ 예약일이 확정된 경우, 예약취소는 담당자에게 문의해주세요.</Typography>
        null
      )
    } else if (reservation.reservationStatus.name === '예약확정') {
      return (
        // <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
        //   <Box sx={{ color: 'grey', flex: 3, textAlign: 'center', p: 1 }}>예약확정 상태입니다. 취소가 불가합니다.</Box>
        //   <Divider orientation="vertical" variant="middle" flexItem />
        //   <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../check/CreateCounsel') }}>문의</Button>
        // </Stack>
        <Typography sx={{ fontSize: 14, color: '#c72a2a', mt: 1 }}>※ 예약일이 확정된 경우, 예약취소는 고객센터(1661-2645) 혹은 '문의' 버튼을 이용해 주세요.</Typography>
      )
    } else if (reservation.reservationStatus.name === '수검완료') {
      return (
        // <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
        //   <Box sx={{ color: 'grey', flex: 3, textAlign: 'center', p: 1 }}>수검완료 상태입니다. 취소가 불가합니다.</Box>
        //   <Divider orientation="vertical" variant="middle" flexItem />
        //   <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../check/CreateCounsel') }}>문의</Button>
        // </Stack>
        <Typography sx={{ fontSize: 14, color: '#c72a2a', mt: 1 }}>※ 수검완료 상태입니다. 취소가 불가합니다.</Typography>
      )
    } else if (reservation.reservationStatus.name === '결과등록') {
      return (
        // <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
        //   <Box sx={{ color: 'grey', flex: 3, textAlign: 'center', p: 1, }}>결과등록 상태입니다. 취소가 불가합니다.</Box>
        //   <Divider orientation="vertical" variant="middle" flexItem />
        //   <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../check/CreateCounsel') }}>문의</Button>
        // </Stack>
        <Typography sx={{ fontSize: 14, color: '#c72a2a', mt: 1 }}>※ 결과등록 상태입니다. 취소가 불가합니다.</Typography>
      )
    }
  }

  // 알림톡 관련 api
  const bizppurio = axios.create({
    baseURL: 'https://api.dualhealth.kr/nodes/bizppurio',
    timeout: 5000
  })

  // 알림톡 함수
  async function sendAT(sendItems: any) {

    let companyInfo = JSON.parse(localStorage.getItem("companyInfo") || '');
    let FAM_INFOS = JSON.parse(localStorage.getItem("FAM_INFO") || '');
    let HOS_INFO = JSON.parse(localStorage.getItem("HOS_INFO") || '');

    const data = {
      type: companyInfo['type'],
      company_id: companyInfo['company_id'],
      company_name: companyInfo['company_name'],
      is_rebate_directly: companyInfo['is_rebate_directly'],
      rebate_price: companyInfo['rebate_price'],
      userName: FAM_INFOS['famName'],
      phone: FAM_INFOS['phone'],
      hospital_name: sendItems.hoName,
      package_name: sendItems.rsvName,
    }

    const info = {
      service: {
        "type": data.type.toLowerCase(),
        "target": data.company_id.includes("#") || data.company_id.toLowerCase() === "dualhealth" ? "customer" : data.company_id.toLowerCase(),
        "name": sendItems.ipiList.includes('심리상담') ? '심리상담' : '건강검진'
      },
      "company": {
        "name": data.company_name,
        "isRebateDirectly": data.is_rebate_directly,
        "rebatePrice": data.rebate_price
      },
      "family": {
        "name": data.userName,
        "phone": data.phone.replaceAll(/[^\d]/ig, "")
      },
      "reservation": {
        "hospitalName": data.hospital_name,
        "packageName": data.package_name,
        // "firstWishDate": data.firstWishDate,
        // "secondWishDate": '-',
        // "confirmedDate": null,
        // "priceToPay": data.price
      }
    }
    const sendMSG = await bizppurio.post('/v1/message?msg=reservation_cancel', info).catch(e => alert("알림톡 전송에 실패했습니다."));
    return sendMSG;
  }


  return (
    <Container className='container'>
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900, }}>
              예약서비스
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#1cb10b', fontWeight: 500, }} gutterBottom>
              예약현황
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ bgcolor: '#e1ede0', mb: 5, width: '82%', mr: 'auto', ml: 'auto', borderRadius: 3 }}>
        <Typography sx={{ display: 'block', fontSize: '14px', color: '#444', fontWeight: 700, p: 0, pt: 3, pb: 0.5, textAlign: 'center' }}>
          예약일이 확정되면 취소가 되지 않습니다.
        </Typography>
        <Typography sx={{ display: 'block', fontSize: '14px', color: '#11a100', fontWeight: 700, p: 0, pb: 3, textAlign: 'center' }}>
          확정 후 예약취소는 고객센터(1661-2645) 혹은 '문의' 버튼을 이용해 주세요.
        </Typography>
      </Box>

      {/* <Box sx={{ bgcolor: '#8949496b', mb: 2, position: 'absolute', left: 0, width: '100%', height: '280px' }}>
        <Typography sx={{
          fontSize: 30,
          fontWeight: 700,
          color: '#fff',
          transform: 'rotateZ(30deg)',
          textAlign: 'center',
          top: '40%',
          position: 'relative',
          border: '6px double #fff',
        }}>
          예약 취소</Typography>
      </Box> */}


      {/* 예약목록 */}
      {
        allListCnt < 1
          ? <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, width: '80%', mr: 'auto', ml: 'auto', borderRadius: 3 }}>
            <EventBusyIcon sx={{ fontSize: 50, color: '#bbb' }} />
            <Typography sx={{ fontSize: 16, color: '#888' }} >예약 정보가 없습니다.</Typography>
            <Box sx={BtnStyle}>
              <Button variant="contained" sx={BottomBtnStyle} onClick={() => { navigate('../reservation') }}>
                건강검진 예약하기
              </Button>
            </Box>
          </Stack>
          : null
      }

      {
        inspectionList.length > 0
          ? <Divider component="div" sx={{ mt: 5, mb: 3, fontSize: 14, color: '#777', width: '80%', ml: 'auto', mr: 'auto' }}><Chip label="건강검진" sx={{ width: 90 }} /></Divider>
          : null
      }


      {/* 건강검진 예약 현황 */}
      {
        inspectionList && inspectionList.map((reservation: any, index: any) => (
          <Box sx={{ p: 2, bgcolor: '#fff', mb: 5, width: '80%', mr: 'auto', ml: 'auto', borderRadius: 3 }}>

            {reservation.reservationStatus.code === -10 ? (
              <Box sx={{ bgcolor: '#8949496b', mb: 2, position: 'absolute', left: 0, width: '100%', height: '280px' }}>
                <Typography sx={{
                  fontSize: 30,
                  fontWeight: 700,
                  color: '#fff',
                  transform: 'rotateZ(30deg)',
                  textAlign: 'center',
                  top: '40%',
                  position: 'relative',
                  border: '6px double #fff',
                }}>
                  예약 취소</Typography>
              </Box>
            ) : (
              null
            )}

            <Stack direction="row" alignItems={'center'} spacing={0} sx={{ p: 0 }}>
              <Typography sx={{ fontSize: 16, ml: 1 }}>{util.strNull(reservation.ipDate) !== '' ? reservation.ipDate : reservation.firstWishDate}{reservation.reservationTime == '0' ? '' : ` ${String(reservation.reservationTime).slice(0, -2)}:${String(reservation.reservationTime).slice(-2)}`}
                <Typography component={'span'} sx={{ fontSize: 12, color: '#999', ml: 0.5 }}>{util.strNull(reservation.ipDate) !== '' ? '예약 확정일' : '예약 희망일'}</Typography> </Typography>
              <Button sx={{ fontSize: 15, ml: 'auto', p: 0, verticalAlign: 'baseline', color: '#888' }}
                onClick={() => { navigate('../reservation/SetFinishDetail', { state: { hoImage: reservation.hoImage, rsvId: reservation.rsvId, url: 'ReservationView' } }) }}>
                상세보기 <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#999' }} />
              </Button>
            </Stack>

            <Card sx={{ borderRadius: 3, mt: 1, }}>
              <Stack direction={'row'} sx={{ p: 2, }}>
                <Box sx={{ p: 2, pt: 0, width: 100 }}>
                  <Typography sx={{ fontSize: 18, fontWeight: 700, mb: 0.5 }}>
                    {reservation.famName}
                  </Typography>
                  <Typography sx={{ fontSize: 14, }}>
                    {`(${reservation.famGrade})`}
                  </Typography>
                </Box>

                <Divider orientation="vertical" flexItem />

                <Stack direction="row" alignItems="center" spacing={2} sx={{ ml: 2, width: 450 }}>
                  <Box sx={{ width: 100, height: 80, display: 'flex' }}>
                    <Img alt="care" src={util.strNull(reservation.hoImage) !== '' ? reservation.hoImage : img01} />
                  </Box>
                  <Stack direction="column" justifyContent="center" spacing={0} sx={{ width: '65%' }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
                      {reservation.hoName}
                    </Typography>
                    <Typography sx={{ fontSize: 12, mt: 0.3, mb: 0.5 }}>
                      {reservation.hoAddress + reservation.hoBuildingNum}
                    </Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, }}>
                      {util.strNull(reservation.ipDate) !== '' ? reservation.ipDate : reservation.firstWishDate}
                      {reservation.reservationTime == '0' ? '' : ` ${String(reservation.reservationTime).slice(0, -2)}:${String(reservation.reservationTime).slice(-2)}`}
                      {reservation.reservationStatus.code <= 0 ? (
                        <Chip label={reservation.reservationStatus.name} size="small" sx={{ ml: 1, verticalAlign: 'top', bgcolor: '#1cb10b', color: '#fff' }}></Chip>
                      ) : (
                        <Chip label={reservation.reservationStatus.name} size="small" variant="outlined" sx={{ ml: 1, verticalAlign: 'top', border: '1px solid #1cb10b', color: '#1cb10b' }}></Chip>
                      )}
                    </Typography>
                  </Stack>
                </Stack>

                <Divider orientation="vertical" flexItem />

                <Stack direction="column" spacing={0} sx={{ p: 2, pt: 0, width: 580 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 700, mb: 0.5 }}>
                    {reservation.rsvName}
                  </Typography>
                  <Typography sx={{ fontSize: 14, wordBreak: 'keep-all' }}>
                    {reservation.ipiList.join(', ')}
                  </Typography>
                </Stack>
              </Stack>

              <Divider />

              {/* <Box sx={{ flex: 3, textAlign: 'center', bgcolor: '#f18322', p: 1 }}>
                      <Typography sx={{ fontWeight: 700, color: '#fff' }}>예약확정</Typography>
                    </Box> */}

              {/* <Box sx={{ flex: 3, textAlign: 'center', bgcolor: '#d20000', p: 1 }}>
                      <Typography sx={{ fontWeight: 700, color: '#fff' }}>예약취소</Typography>
                    </Box> */}

              {
                reservation.reservationStatus.code === 0
                  ? (
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
                      <Button sx={{ color: '#555', flex: 3, textAlign: 'center', p: 1 }}
                        onClick={() => handleClickOpen(reservation.hoName, reservation.firstWishDate, reservation.rsvId, reservation)}>예약취소</Button>
                      <Divider orientation="vertical" variant="middle" flexItem />
                      <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../check/CreateCounsel') }}>문의</Button>
                    </Stack>
                  )
                  : (
                    // <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
                    //   <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../check/CreateCounsel') }}>문의</Button>
                    // </Stack>
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
                      <Box sx={{ color: 'grey', flex: 3, textAlign: 'center', p: 1, fontSize: 14, ":hover": { cursor: 'not-allowed' } }}>취소불가</Box>
                      <Divider orientation="vertical" variant="middle" flexItem />
                      <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../check/CreateCounsel') }}>문의</Button>
                    </Stack>
                  )
              }
            </Card>

            {
              showStatus(reservation) // 예약 상태에 따른 문구
            }
          </Box>
        ))
      }

      {/* 심리상담 예약 현황 */}
      {
        counselList.length > 0
          ? <Divider component="div" sx={{ mt: 7, mb: 3, fontSize: 14, color: '#777', width: '80%', ml: 'auto', mr: 'auto' }}><Chip label="심리상담" sx={{ width: 90 }} /></Divider>
          : null
      }

      {
        counselList && counselList.map((reservation: any, index: any) => (
          <Box sx={{ p: 2, bgcolor: '#fff', mb: 5, width: '80%', mr: 'auto', ml: 'auto', borderRadius: 3 }}>
            {
              reservation.reservationStatus.code === -10 ? (
                <Box sx={{ bgcolor: '#8949496b', mb: 2, position: 'absolute', left: 0, width: '100%', height: '280px' }}>
                  <Typography sx={{
                    fontSize: 30,
                    fontWeight: 700,
                    color: '#fff',
                    transform: 'rotateZ(30deg)',
                    textAlign: 'center',
                    top: '40%',
                    position: 'relative',
                    border: '6px double #fff',
                  }}>
                    예약 취소</Typography>
                </Box>
              ) : (
                null
              )
            }

            <Stack direction="row" alignItems={'center'} spacing={0} sx={{ p: 0 }}>
              <Typography sx={{ fontSize: 16, ml: 1 }}>{util.strNull(reservation.ipDate) !== '' ? reservation.ipDate : reservation.firstWishDate}
                <Typography component={'span'} sx={{ fontSize: 12, color: '#999', ml: 0.5 }}>{util.strNull(reservation.ipDate) !== '' ? '예약 확정일' : '예약 희망일'}
                <Chip label={`${reservation.count}차`} size="small" variant="outlined" sx={{ ml: 1, border: '1px solid #1cb10b', color: '#1cb10b' }}></Chip>
                </Typography>
              </Typography>
              <Button sx={{ fontSize: 15, ml: 'auto', p: 0, verticalAlign: 'baseline', color: '#888' }}
                onClick={() => { navigate('../reservation/SetFinishDetail', { state: { hoImage: reservation.hoImage, rsvId: reservation.rsvId } }) }}>
                상세보기 <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#999' }} />
              </Button>
            </Stack>

            <Card sx={{ borderRadius: 3, mt: 1, }}>
              <Stack direction={'row'} sx={{ p: 2, }}>
                <Box sx={{ p: 2, pt: 0, width: 100 }}>
                  <Typography sx={{ fontSize: 18, fontWeight: 700, mb: 0.5 }}>
                    {reservation.famName}
                  </Typography>
                  <Typography sx={{ fontSize: 14, }}>
                    {`(${reservation.famGrade})`}
                  </Typography>
                </Box>

                <Divider orientation="vertical" flexItem />

                <Stack direction="row" alignItems="center" spacing={2} sx={{ ml: 2, width: 450 }}>
                  <Box sx={{ width: 100, height: 80, display: 'flex' }}>
                    <Img alt="care" src={util.strNull(reservation.hoImage) !== '' ? reservation.hoImage : img01} />
                  </Box>
                  <Stack direction="column" justifyContent="center" spacing={0} sx={{ width: '65%' }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
                      {reservation.hoName}
                    </Typography>
                    <Typography sx={{ fontSize: 12, mt: 0.3, mb: 0.5 }}>
                      {reservation.hoAddress + reservation.hoBuildingNum}
                    </Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, }}>
                      {reservation.firstWishDate} {String(reservation.reservationTime).slice(0, -2)}:{String(reservation.reservationTime).slice(-2)}
                      {reservation.reservationStatus.code <= 0 ? (
                        <Chip label={reservation.reservationStatus.name} size="small" sx={{ ml: 1, verticalAlign: 'top', bgcolor: '#1cb10b', color: '#fff' }}></Chip>
                      ) : (
                        <Chip label={reservation.reservationStatus.name} size="small" variant="outlined" sx={{ ml: 1, verticalAlign: 'top', border: '1px solid #1cb10b', color: '#1cb10b' }}></Chip>
                      )}
                    </Typography>
                  </Stack>
                </Stack>

                <Divider orientation="vertical" flexItem />

                <Stack direction="column" spacing={0} sx={{ p: 2, pt: 0, width: 580 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 700, mb: 0.5 }}>
                    {reservation.rsvName}
                  </Typography>
                  <Typography sx={{ fontSize: 14, }}>
                    {reservation.ipiList.join(', ')}
                  </Typography>
                </Stack>

              </Stack>

              <Divider />

              {
                reservation.reservationStatus.code === 0
                  ? (
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
                      <Button sx={{ color: '#555', flex: 3, textAlign: 'center', p: 1 }}
                        onClick={() => handleClickOpen(reservation.hoName, reservation.firstWishDate, reservation.rsvId, reservation)}>예약취소</Button>
                      <Divider orientation="vertical" variant="middle" flexItem />
                      <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../check/CreateCounsel') }}>문의</Button>
                    </Stack>
                  )
                  : (
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
                      <Box sx={{ color: 'grey', flex: 3, textAlign: 'center', p: 1, fontSize: 14, ":hover": { cursor: 'not-allowed' } }}>취소불가</Box>
                      <Divider orientation="vertical" variant="middle" flexItem />
                      <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../check/CreateCounsel') }}>문의</Button>
                    </Stack>
                  )
              }
            </Card>
            {
              showStatus(reservation) // 예약 상태에 따른 문구
            }
          </Box>
        ))
      }


      <Dialog
        open={open}
        onClose={handleClose}
        sx={{ '& .MuiDialog-paper': { borderRadius: 4 } }}
      >
        {/* <DialogTitle sx={{ fontSize: 18, fontWeight: 700, textAlign:'center' }}>
          예약을 취소하시나요?
        </DialogTitle> */}
        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton> */}
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <Stack direction="column" justifyContent="center" alignItems={'center'} spacing={0} sx={{}}>
              <EventBusyIcon sx={{ fontSize: 50, color: '#bbb', mb: 1, mt: 1 }} />
              <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
                {selectedHoName}
              </Typography>
              <Typography sx={{ fontSize: 16, fontWeight: 700, m: 1, mb: 2 }}>
                {selectedIpDate}
              </Typography>
              <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#ff5555', mb: 1 }}>
                예약을 취소하시겠습니까?
              </Typography>
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', '&.MuiDialogActions-root': { p: 0, } }}>

          <Button onClick={handleClose} sx={{ flex: 1, bgcolor: '#f0f0f0', p: 1, borderRadius: 0, color: '#444' }}>
            닫기
          </Button>
          {/* <Divider orientation="vertical" variant="fullWidth" flexItem /> */}
          <Button onClick={handleClickCancleReservation} sx={{ flex: 1, bgcolor: '#11a100', p: 1, borderRadius: 0, m: '0 !important', color: '#fff', fontWeight: 700, }}>
            취소하기
          </Button>

        </DialogActions>
      </Dialog>

      <Bottom />
    </Container >
  );
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: '3 0',
  mt: 8,
  boxSizing: 'border-box',
  width: '80%',
};

const BottomBtnStyle = {
  width: '80%',
  hegiht: 60,
  bgcolor: '#0d6703',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px',
  p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #0d6703',
  ':hover': {
    backgroundColor: '#074300',
    borderColor: '#074300',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#0d6703',
    borderColor: '#0d6703',
  },
  ':focus': {
    boxShadow: 'none',
  },
};


const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}



export default ReservationView;